export default "__VITE_ASSET__ClYZTVTS__"